import type { InteractionManager } from '../InteractionManager';
import { getCanvasLogicalSize } from './canvasLogicalSize';

export class HoverTooltipRenderer {
    constructor(private readonly canvas: HTMLCanvasElement) {}

    public drawHoveredActorTooltip(ctx: CanvasRenderingContext2D, interactionManager: InteractionManager): void {
        const hoveredActor = interactionManager.getHoveredActor();
        const hoverPointer = interactionManager.getHoverPointer();

        if (!hoveredActor || !hoverPointer || typeof hoveredActor.hp !== 'number') {
            return;
        }

        const hpText = Math.round(hoveredActor.hp);
        const maxHpText = typeof hoveredActor.maxHp === 'number' ? ` / ${Math.round(hoveredActor.maxHp)}` : '';
        const staminaText =
            typeof hoveredActor.stamina === 'number'
                ? `  ST: ${Math.round(hoveredActor.stamina)}${typeof hoveredActor.maxStamina === 'number' ? ` / ${Math.round(hoveredActor.maxStamina)}` : ''}`
                : '';
        const text = `HP: ${hpText}${maxHpText}${staminaText}`;
        const x = hoverPointer.x + 12;
        const y = hoverPointer.y - 28;

        ctx.save();
        ctx.font = '12px Arial, sans-serif';
        const textWidth = ctx.measureText(text).width;
        const width = textWidth + 16;
        const height = 22;
        const canvasSize = getCanvasLogicalSize(this.canvas);
        const drawX = Math.max(8, Math.min(x, canvasSize.width - width - 8));
        const drawY = Math.max(8, Math.min(y, canvasSize.height - height - 8));

        ctx.fillStyle = 'rgba(10, 14, 20, 0.92)';
        ctx.strokeStyle = 'rgba(148, 163, 184, 0.7)';
        ctx.lineWidth = 1;
        ctx.fillRect(drawX, drawY, width, height);
        ctx.strokeRect(drawX, drawY, width, height);

        ctx.fillStyle = '#e5e7eb';
        ctx.textAlign = 'left';
        ctx.textBaseline = 'middle';
        ctx.fillText(text, drawX + 8, drawY + height / 2 + 0.5);
        ctx.restore();
    }
}
